import type { ReactNode } from 'react';

interface Props {
  eyebrow?: ReactNode;
  title: ReactNode;
  crumb?: ReactNode;
  actions?: ReactNode;
  sub?: ReactNode;
}

export function PageHeader({ eyebrow, title, crumb, actions, sub }: Props): JSX.Element {
  return (
    <div className="page-hd">
      <div>
        {crumb ? <div className="crumb">{crumb}</div> : null}
        {eyebrow ? <div className="eb">{eyebrow}</div> : null}
        <h1 className="d-title">{title}</h1>
        {sub ? <div className="d-meta" style={{ marginTop: 6 }}>{sub}</div> : null}
      </div>
      {actions ? (
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>{actions}</div>
      ) : null}
    </div>
  );
}
